var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"item"},[_c('menu-link',{attrs:{"href":_vm.item.url}},[_vm._v(_vm._s(_vm.sanitize(_vm.item.title)))]),(_vm.item.child_items)?_c('ul',{staticClass:"sub-menu"},_vm._l((_vm.item.child_items),function(childItem){return _c('menu-item',{key:childItem.ID,attrs:{"item":childItem}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }